// * UIID: 
// * UI Name:  Custom resizeTableHeight
// * Modify Date: 2020/09/24

import $ from "jquery";

export function resizeTableHeight(arrClassMinus, arrClassPlus, pagingBottom = false, multiTrans = false) {
  let winHeight = $(window).height();
  let paddingBottom = 15;
  let arrMinusDefault = ['.page-header', '.custom-form-control', '.btn-form-control'];
  //  Min table height
  let minTableheight = 200;
  let headerHeight = $('header.smartlink-header').outerHeight(true);
  let footerHeight = $('footer.v-footer').outerHeight(true);
  let tableHeight = winHeight - paddingBottom - headerHeight - footerHeight;

  if (typeof arrClassMinus != 'undefined') {
    let sumArrMinusHeight = arrMinusDefault.concat(arrClassMinus);
    let tempHeight;
    sumArrMinusHeight.forEach(element => {
      tempHeight = $(element).outerHeight(true);
      if (typeof tempHeight != 'undefined') {
        tableHeight = tableHeight - tempHeight;
        // 2021.11.19 203728 SPKA-260
        if (pagingBottom) tableHeight = tableHeight - 15;
        if (multiTrans) tableHeight = tableHeight - 20;
      }
    });
  } else {
    let tempHeight;
    arrMinusDefault.forEach(element => {
      tempHeight = $(element).outerHeight(true);
      if (typeof tempHeight != 'undefined') {
        tableHeight = tableHeight - tempHeight;
      }
    });
  }

  if (typeof arrClassPlus != 'undefined') {
    arrClassPlus.forEach(element => {
      let tempHeight = $(element).outerHeight(true);
      if (typeof tempHeight != 'undefined') {
        tableHeight = tableHeight + tempHeight;
      }
    });
  }

  if (tableHeight <= minTableheight) {
    $(".container").css('margin-bottom', (headerHeight + footerHeight));
    $(".container").css('padding-bottom', paddingBottom);
  } else {
    $(".container").css('margin-bottom', 0);
  }
  // console.log('tableHeight'+tableHeight)
  return tableHeight > minTableheight ? tableHeight : minTableheight;
}

/**
 * Compare value function for valueA and valueB
 * @param {} propa 
 * @param {} propb 
 * @param {} sortCond: asc/desc
 * @returns -1, 0, 1
*/
const compareSort = function (propa, propb, sortCond) {
  if (propa > propb) {
    if (sortCond == 'asc') {
      return 1;
    }
    return -1;
  } else if (propa < propb) {
    if (sortCond == 'asc') {
      return -1;
    }
    return 1;
  }
  return 0;
}
/**
 * Get index each item in array data throught id
 * @param {} id: id of each item
 * @param {} arrData: array data
 * @returns index of item in array
*/
const getIndexItem = function (id, arrData) {
  return arrData.map(function (item) { return item.id; }).indexOf(id) + 1;
}

const nullOrEmpty = function (str, addItem = "") {
  if (
    str === null ||
    str === "" ||
    str === undefined ||
    str === "undefined" ||
    /^ *$/.test(str)
  ) {
    str = "";
  } else {
    str += addItem;
  }
  return str;
}

export { compareSort };
export { getIndexItem };
export { nullOrEmpty };